const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
  minWidth: '150px',
};
const style2 = {
  backgroundColor: '#00B050',
  color: '#fff',
};

export const HeaderStandard = [
  [
    { text: 'S.NO.', style: style1 },
    { text: 'CHECK POINTS', style: style1 },
    { text: 'METHOD', style: style1 },
    { text: 'STANDARD', style: style1 },
    { text: 'OBSERVATIONS', style: style1 },
    { text: 'JUDGEMENT (OK/NG)', style: style1 },
    { text: 'REMARK', style: style1 },
    { text: 'ACTION', style: { ...style1, backgroundColor: '#c92a2a' } },
  ],
];

export const listConstant = {
  childHeader: 'PROCESS AUDIT Checksheet list',
  addButtonLable: 'New Checksheet',
};

export const headerConstant = {
  tableCompHeadTitle: 'PROCESS AUDIT CHECK SHEET FOR',
};

export const apiConstant = {
  get: 'masterCheckListRouteProcessAuditPlan',
  getById: 'masterCheckListRouteProcessAuditPlan',
  post: 'masterCheckListRouteProcessAuditPlan',
  update: 'masterCheckListRouteProcessAuditPlan',
  delete: 'masterCheckListRouteProcessAuditPlan',
  forAutoComplete: 'moldRoutes/workersList/workersForAutoComplete',
  departmentAutoComplete: 'department',
};

export const tilesConstant = {
  childHeaderText: 'PROCESS AUDIT PLAN',
};

export const navigationConstant = {
  createEditChecklist: '/common/processAuditPlan_ChecklistCreate',
};
